import { AppThunk } from "../../store";
import { adminProviderActions } from "./adminProviderSlice";
import { apiFetch } from "../../../utils/api";

export const fetchProvidersByStatus =
  (status: "PENDING" | "VERIFIED" | "REJECTED" = "PENDING"): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(adminProviderActions.startLoading());
      const data = await apiFetch(
        `/api/admin/providers?status=${status}`,
        {},
        true
      );
      dispatch(adminProviderActions.setProviders(data));
    } catch (e: any) {
      dispatch(adminProviderActions.setError(e.message));
    } finally {
      dispatch(adminProviderActions.endLoading());
    }
  };

export const verifyProvider =
  (providerId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(adminProviderActions.startLoading());
      await apiFetch(`/api/admin/providers/${providerId}/verify`, { method: "PUT" }, true);
      dispatch(adminProviderActions.removeProvider(providerId));
    } catch (e: any) {
      dispatch(adminProviderActions.setError(e.message));
    } finally {
      dispatch(adminProviderActions.endLoading());
    }
  };

export const rejectProvider =
  (providerId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(adminProviderActions.startLoading());
      await apiFetch(`/api/admin/providers/${providerId}/reject`, { method: "PUT" }, true);
      dispatch(adminProviderActions.removeProvider(providerId));
    } catch (e: any) {
      dispatch(adminProviderActions.setError(e.message));
    } finally {
      dispatch(adminProviderActions.endLoading());
    }
  };
